<div class="page page-support">
    <div class="page-header page-header-support page-header-tall">
        <div class="container">
            <div *ngIf="!loading" class="row">
                <div class="col-auto">
                    <div class="page-title">{{ pageName }}</div>
                </div>
                <div class="col-auto">
                    <strong class="page-header-sidebar">
                        Questions? <a class="text-blue" href="/sales_support/contact">Contact Us!</a>
                    </strong>
                </div>
            </div>
        </div>
    </div>

    <div class="page-body container">
        <div class="row wide-gutters" *ngIf="!loading">
            <ycn-support-sidebar class="tabs tabs-vertical col-3"
                    *ngIf="activeCategory"
                    [selectedCategory]="activeCategory"
                    [(selectedContentId)]="activeContentId"
                    [categories]="categories"
                    (selectedCategoryChange)="updateActiveCategoryOnClick($event)">
            </ycn-support-sidebar>
            <div class="tab-content col-8 col-lg-9">
                <div [hidden]="!(contactCategory && (contactCategory.id === activeCategory?.id))">
                    <ycn-support-contact-info-page></ycn-support-contact-info-page>
                </div>
                <div *ngIf="!activeCategory?.user_has_access"
                    [innerHTML]="activeCategory?.sanitized_upsell_html">
                </div>
                <ng-container *ngIf="activeCategory?.user_has_access
                                                    && (!contactCategory || (contactCategory.id !== contactCategory?.id))">
                    <div class="tab-pane active" *ngFor="let content of activeContentList">
                        <div class="topics-section">
                            <div id="{{ content.slug }}" class="topics-section-header">
                                {{ content.title }}
                            </div>
                            <div class="topics-section-body">
                                <div [innerHTML]="content.sanitized_body">
                                </div>
                            </div>
                            <hr class="divider-horizontal mt-3 mb-3">
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
